import { Pipe, PipeTransform } from '@angular/core';
import { Hex } from 'viem';
import { getPaletteForAddress } from '../services/avatar.service';

export function addressToColor(address: string): string {
  return getPaletteForAddress(address).outline;
}

@Pipe({
  name: 'addressColor',
  pure: true,
})
export class AddressColorPipe implements PipeTransform {
  transform(address: Hex | string): string {
    return addressToColor(address);
  }
}